export const SearchIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1554_9919)">
        <path
          d="M9.61328 15C13.0651 15 15.8633 12.2018 15.8633 8.75C15.8633 5.29822 13.0651 2.5 9.61328 2.5C6.1615 2.5 3.36328 5.29822 3.36328 8.75C3.36328 12.2018 6.1615 15 9.61328 15Z"
          stroke="#A5A5A5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0391 13.1699L18.3695 17.5004"
          stroke="#A5A5A5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1554_9919">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.859375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
